// Trava de horário da sala de teleconsulta. Dois relógios diferentes:
//
// 1. Sala de espera (WaitingRoomView): o botão "Entrar na consulta" libera
//    ENTRY_LOCK_MINUTES antes do scheduled_at — é só uma folga pra testar
//    câmera/mic e aguardar. unlockAt/isLocked/formatUnlockCountdown usam esse
//    valor por padrão.
// 2. Sala de consulta (MeetingRoomView): a chamada em si (quem chega direto
//    pela URL, ou vem da sala de espera já liberada) só entra no horário
//    EXATO marcado — sem a folga dos 10 min. isBeforeCallStart/
//    formatCallCountdown existem pra isso (equivalentes com minutesBefore=0).
//
// Vale igual para médico e paciente — sem exceção de papel.
export const ENTRY_LOCK_MINUTES = 10;

export function unlockAt(scheduledAt, minutesBefore = ENTRY_LOCK_MINUTES) {
  if (!scheduledAt) return null;
  return new Date(scheduledAt).getTime() - minutesBefore * 60000;
}

export function isLocked(
  scheduledAt,
  now = Date.now(),
  minutesBefore = ENTRY_LOCK_MINUTES
) {
  const unlock = unlockAt(scheduledAt, minutesBefore);
  if (unlock === null) return false;
  return now < unlock;
}

// Texto do contador até a liberação ("Faltam N minutos/horas/dias").
export function formatUnlockCountdown(
  scheduledAt,
  now = Date.now(),
  minutesBefore = ENTRY_LOCK_MINUTES
) {
  const unlock = unlockAt(scheduledAt, minutesBefore);
  if (unlock === null) return "";

  const diffMs = Math.max(0, unlock - now);
  const minutes = Math.ceil(diffMs / 60000);
  if (minutes < 60) {
    return minutes <= 1 ? "Falta 1 minuto" : `Faltam ${minutes} minutos`;
  }

  const hours = Math.ceil(diffMs / 3600000);
  if (hours < 24) {
    return hours <= 1 ? "Falta 1 hora" : `Faltam ${hours} horas`;
  }

  const days = Math.ceil(diffMs / 86400000);
  return days <= 1 ? "Falta 1 dia" : `Faltam ${days} dias`;
}

// Sala de consulta: locked até o horário exato marcado (minutesBefore = 0).
export function isBeforeCallStart(scheduledAt, now = Date.now()) {
  return isLocked(scheduledAt, now, 0);
}

export function formatCallCountdown(scheduledAt, now = Date.now()) {
  return formatUnlockCountdown(scheduledAt, now, 0);
}
